export default __webpack_public_path__ + "static/media/business-license-image-1.b452b42e.png";